export default {
    previousText: 'Précédent',
    nextText: 'Suivant',
    loadingText: 'Chargement...',
    noDataText: 'Aucune donnée trouvée',
    pageText: 'Page',
    ofText: 'de',
    rowsText: 'lignes',
    defaultPageSize:20,
    className:"-striped -highlight",
    collapseOnDataChange: false
}


// WEBPACK FOOTER //
// ./src/components/shared/utils/reactTableProps.js